import React from 'react';

const WhatsAppButton = () => {
  const phoneNumber = '14377570478'; // +1 (437) 757-0478 in international format
  const message = encodeURIComponent(
    'Hi VK Tax Guide! I would like to know more about your tax filing services.'
  );
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  const handleClick = () => {
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleClick}
      data-testid="whatsapp-chat-button"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 active:scale-95 group"
      aria-label="Chat on WhatsApp"
    >
      <div className="relative">
        {/* Official WhatsApp Logo */}
        <svg
          className="w-7 h-7"
          viewBox="0 0 32 32"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16 0C7.164 0 0 7.164 0 16c0 2.825.738 5.488 2.031 7.794L0 32l8.394-2.031C10.7 31.263 13.362 32 16 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.5c-2.538 0-4.95-.7-7-1.913l-.506-.3-5.231 1.263 1.263-5.231-.3-.506C3.2 20.95 2.5 18.538 2.5 16 2.5 8.544 8.544 2.5 16 2.5S29.5 8.544 29.5 16 23.456 29.5 16 29.5z"/>
          <path d="M22.744 18.756c-.394-.2-2.331-1.156-2.694-1.288-.362-.131-.625-.2-.887.2-.263.4-1.019 1.288-1.25 1.55-.231.263-.462.3-.856.1-.394-.2-1.663-.612-3.169-1.956-1.169-1.044-1.956-2.331-2.187-2.725-.231-.394-.025-.606.175-.8.181-.175.394-.462.594-.694.2-.231.263-.394.394-.656.131-.263.069-.494-.031-.694-.1-.2-.887-2.138-1.219-2.925-.325-.769-.656-.669-.887-.681-.231-.012-.494-.012-.756-.012s-.694.1-1.056.494c-.362.394-1.381 1.35-1.381 3.294s1.412 3.819 1.612 4.081c.2.263 2.825 4.313 6.844 6.05.956.413 1.7.656 2.281.838.956.306 1.831.263 2.519.163.769-.113 2.331-.956 2.656-1.881.325-.925.325-1.719.231-1.881-.094-.163-.356-.263-.75-.463z"/>
        </svg>
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-pulse" />
      </div>
      
      {/* Tooltip */}
      <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
        Chat with us on WhatsApp
        <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full">
          <div className="border-8 border-transparent border-l-gray-900" />
        </div>
      </div>
    </button>
  );
};

export default WhatsAppButton;
